import * as React from 'react';

/**
 *
 * IspSerpBox component
 * @extends {React.PureComponent<IIspSerpProps<IIspSerpData>>}
 */
class IspSerpBox extends React.Component {
    public render(): JSX.Element | null {
        /* tslint:disable:no-string-literal */
        function localIspApiDoFullTextSearch():boolean {
            if (window['ispApiDoFullTextSearch'] !== undefined) {
                return window['ispApiDoFullTextSearch']();
            }
            return false;
        }
        /* tslint:enable:no-string-literal */
        return (
            <>
                <div
                        id='isp_search_box_container'
                        className='isp_search_box_container isp_center_container_position'
                >
                        <form>
                            <input
                                type='search'
                                id='isp_main_search_box'
                                className='isp_search_box'
                                data-placeholder-live='false'
                                placeholder='Search...'
                            />
                            <input
                                type='button'
                                style={{display: 'none'}}
                                title='Click to search'
                                id='isp_icon_id'
                                className='isp_transparent_icon'
                                onClick={localIspApiDoFullTextSearch}
                            />
                            <a
                                target='_blank'
                                rel='nofollow'
                                href='https://www.instantsearchplus.com/instantsearchplus-autocomplete-bigcommerce?src=bigcommerce_fulltextsearch'
                                className='isp_watermark'
                                style={{display: 'none'}}
                            >
                                <span className='isp_watermark_text'>Powered by </span>
                                    <img
                                        src='https://cdn1-gae-ssl-default.akamaized.net/images/site_search_plus_16x16.png'
                                        alt=''
                                        id='isp_watermark_img'
                                        role='presentation'
                                    />
                                <span style={{font: 'bold', color: '#666'}} className='isp_watermark_text'> InstantSearch+</span>
                            </a>
                        </form>
                </div>
            </>
        );
    }
}
export default IspSerpBox;